export const CHAINS = [
    {
    chainId: 181,
    name: 'Waterfall',
    currency: 'WATER',
    explorerUrl: 'https://explorer.waterfall.network/',
    rpcUrl: 'https://rpc.waterfall.network',
  },
  {
    chainId: 1501869,
    name: 'Waterfall testnet 9',
    currency: 'WATER',
    explorerUrl: 'https://explorer.testnet9.waterfall.network',
    rpcUrl: 'https://rpc.testnet9.waterfall.network/',
  },
]
